import Config from "~config/env"

export const WS_URL = Config.WS_URL
export const API_URL = Config.API_URL
export const CDN_URL = Config.CDN_URL || API_URL
export const ENCRYPT_KEY = Config.ENCRYPT_KEY || '4JWRTfJGFPr6rNEqNHSz1ZVJi6YVOyfs-I_QqtFBYQc='
